import { render } from "./sport-live-tv-event-grid.vue?vue&type=template&id=698ea6c0&scoped=true"
const script = {}

import "./sport-live-tv-event-grid.vue?vue&type=style&index=0&id=698ea6c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ea6c0"]])

export default __exports__